function initialState() {
  return {
    isAlterarCampos: true,
    isDupla: false
  };
}

const mutations = {
  updateIsAlterarCampos(state, isAlterarCampos) {
    state.isAlterarCampos = isAlterarCampos;
  },
  updateIsDupla(state, isDupla) {
    state.isDupla = isDupla
  }
};

const actions = {
  setIsAlterarCampos(state, isAlterarCampos) {
    state.commit("updateIsAlterarCampos", isAlterarCampos);
  },
  setIsDupla(state, isDupla) {
    state.commit("updateIsDupla", isDupla);
  }
};

const namespaced = true;

const atendimento = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default atendimento;



// WEBPACK FOOTER //
// ./src/store/atendimento.js